function ConditionalFormattingIcon({
  width = 16,
  height = 12
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4286 0H0.571429C0.255357 0 0 0.24375 0 0.545455V11.4545C0 11.7563 0.255357 12 0.571429 12H15.4286C15.7446 12 16 11.7563 16 11.4545V0.545455C16 0.24375 15.7446 0 15.4286 0ZM14.7143 3.54545H10.9286V1.22727H14.7143V3.54545ZM14.7143 7.36364H10.9286V4.63636H14.7143V7.36364ZM6.21429 4.63636H9.78571V6V7.36364H6.21429V6V4.63636ZM9.78571 3.54545H6.21429V1.22727H9.78571V3.54545ZM1.28571 4.63636H5.07143V7.36364H1.28571V4.63636ZM1.28571 1.22727H5.07143V3.54545H1.28571V1.22727ZM1.28571 8.45455H5.07143V10.7727H1.28571V8.45455ZM6.21429 8.45455H9.78571V10.7727H6.21429V8.45455ZM14.7143 10.7727H10.9286V8.45455H14.7143V10.7727Z"
        fill="black"
        fillOpacity="0.88"
      />
      <path
        d="M14.7143 10.7727H10.9286V8.45455H14.7143V10.7727Z"
        fill="white"
      />
      <path
        d="M9.78571 7.36364H6.21429V4.63636H9.78571V7.36364Z"
        fill="#B4A0FF"
      />
      <path
        d="M5.07143 3.54545H1.28571V1.22727H5.07143V3.54545Z"
        fill="#B4A0FF"
      />
      <path
        d="M5.07143 10.7727H1.28571V8.45455H5.07143V10.7727Z"
        fill="#B4A0FF"
      />
      <path
        d="M5.07143 7.36364H1.28571V4.63636H5.07143V7.36364Z"
        fill="#B4A0FF"
      />
    </svg>
  );
}

export default ConditionalFormattingIcon;
